/* ============================================
   <results-timeline> Web Component
   Sticky scroll-lock with progress bar
   Budget: < 1.5KB uncompressed
   ============================================ */

class ResultsTimeline extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.showAllActive();
      return;
    }

    this.progressBar = this.querySelector('.results-timeline__progress');
    this.milestones = this.querySelectorAll('[data-milestone]');
    this.track = this.querySelector('.results-timeline__track');

    if (!this.progressBar || this.milestones.length === 0 || !this.track) return;

    this.ticking = false;
    this.activated = false;

    var self = this;
    var staggerWait = (this.milestones.length - 1) * 80 + 500;

    var entryObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            self.classList.add('is-progress-active');
            self.activated = true;
            self.onScroll();
          }, staggerWait);
          entryObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });

    entryObserver.observe(this);

    this._onScroll = function () {
      if (!self.activated) return;
      if (!self.ticking) {
        requestAnimationFrame(function () {
          self.onScroll();
          self.ticking = false;
        });
        self.ticking = true;
      }
    };

    this._onResize = function () {
      if (self.activated) self.onScroll();
    };

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
  }

  disconnectedCallback() {
    if (this._onScroll) {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }
  }

  onScroll() {
    /* The runway (this element) is taller than the viewport.
       Progress = how far the runway top has scrolled past viewport top,
       as a fraction of the total scrollable distance (runway height - viewport height). */
    var rect = this.getBoundingClientRect();
    var viewH = window.innerHeight;
    var scrollDistance = rect.height - viewH;
    var isDesktop = window.innerWidth >= 990;

    if (scrollDistance <= 0) return;

    var progress = -rect.top / scrollDistance;
    progress = Math.max(0, Math.min(1, progress));

    if (isDesktop) {
      this.progressBar.style.width = (progress * 100) + '%';
      this.progressBar.style.height = '';
    } else {
      this.progressBar.style.height = (progress * 100) + '%';
      this.progressBar.style.width = '';
    }

    var total = this.milestones.length;
    this.milestones.forEach(function (milestone, i) {
      var threshold = total > 1 ? i / (total - 1) : 0;
      milestone.classList.toggle('is-active', progress >= threshold);
    });
  }

  showAllActive() {
    this.querySelectorAll('[data-milestone]').forEach(function (m) {
      m.classList.add('is-active');
    });
  }
}

customElements.define('results-timeline', ResultsTimeline);
